import React, { useState } from "react"; // seState, // Fragment,
import { observer, inject } from "mobx-react";
// import orderBy from "lodash/orderBy";
// import { PaddingBottom } from "ComponentsUI/Spacings";
// import NewsContainer from "./Containers/NewsContainer";
// import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
// import Routes from "Configs/routes";
import { generateUrl } from "Services/withDefaultParams";
// import FiltersContainer from "./Containers/FiltersContainer";
// import Stub from "./Containers/Stub";
import {
	// useLocation,
	useParams,
	withRouter,
} from "react-router-dom";
import {
	// Redirect404,
	RedirectPagination,
} from "ComponentsUI/Redirects";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";
import ActionTariffsContainer from "./Containers/ActionTariffsContainer";
import { pipe } from "Utils/index";
import {
	// useNewsQuery,
	useTariffsActionsQuery,
} from "./hooks";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import { isMainSiteCode } from "Utils/siteConfig";
import { SeoBlockContainer } from "Containers/SeoBlock";
import Container from "reactstrap/lib/Container";
import SeoBlockHOC from "HOC/SeoBlockHOC";

// const LIMIT = 20;

const _Actions = (props) => {
	const params = useParams();
	const match = useWithDefaultParams();
	// const location = useLocation();

	const {
		ApplicationModel: {
			siteConfig,
			// windowSizeModel, text
		},
	} = props;

	const canonical = () => {
		let location = generateUrl(configRouters.Actions.route, {
			regionUrl: params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	// const { loading } = props;
	const siteCode = props.ApplicationModel.siteCode;

	// const { data: newsData } = useNewsQuery();

	const [currentSort, setCurrentSort] = useState("");
	const { tariffs, isLoading } = useTariffsActionsQuery(currentSort);

	// if (!newsData || loading || isLoading) {
	//     return <Stub />;
	// }

	// const {
	//     news,
	//     newsAggregate
	// } = newsData;

	// let countTariffs = tariffs.length;

	// let page = 1;
	// if (params.page > -1) {
	//     page = parseInt(params.page);
	// }
	if (match.params.page === "1") {
		return <RedirectPagination />;
	}

	// if (!page || news.pagination.items_total < LIMIT * (page - 1)) {
	//     return (
	//         <Redirect404
	//             message404={
	//                 "Выбрана пагинация больше доступной в акциях региона"
	//             }
	//         />
	//     );
	// }

	// let pagination = news?.pagination;
	// let pageTotal = Math.ceil(pagination.items_total / 20);
	// pagination = {
	//     ...pagination,
	//     per_page: 20,
	//     page_current: page,
	//     page_total: pageTotal,
	// };

	// const path = generateUrl(Routes.Actions.route, {
	//     regionUrl: match.params.regionUrl,
	// });

	// let sortedAggregation = {};
	// for (let it in newsAggregate.aggregation) {
	//     sortedAggregation[it] = orderBy(
	//         newsAggregate.aggregation[it],
	//         "name",
	//         "asc"
	//     );
	// }

	sendMetriks("OPEN_ACTION_REGION");

	return (
		<React.Fragment>
			{canonical()}
			{isMainSiteCode(siteCode) && <div></div>}
			<SeoBlockHOC route={props.route} placeText="ActionTariffs">
				<ActionTariffsContainer
					{...props}
					tariffsActionsPage={tariffs}
					isLoading={isLoading}
					onFilterChange={(filterType) => {
						setCurrentSort(filterType.key);
					}}
				/>
			</SeoBlockHOC>
			<Container>
				<SeoBlockContainer route={props.route} placeText="SeoBlock2" bgText={true} />
				<SeoBlockContainer route={props.route} placeText="SeoBlock3" bgText={true} />
			</Container>
			{/*Все акции были отключены, фильтр без акций не работает, поэтому был отключен и запрос на агрегацию тоже, т.к. выполнялся слишком долго*/}
			{/*<FiltersContainer*/}
			{/*    text={text}*/}
			{/*    aggregation={sortedAggregation}*/}
			{/*    windowSizes={windowSizeModel.windowSizes}*/}
			{/*    tariffsCount={countTariffs}*/}
			{/*/>*/}
			{/*<PaddingBottom>*/}
			{/*    <NewsContainer*/}
			{/*        text={text}*/}
			{/*        // noModal={true}*/}
			{/*        items={news.data}*/}
			{/*        tariffsCount={countTariffs}*/}
			{/*        aggregation={sortedAggregation}*/}
			{/*    />*/}
			{/*</PaddingBottom>*/}
			{/*<Paginator*/}
			{/*    datatest="actions_browsing"*/}
			{/*    location={location}*/}
			{/*    itemsTotal={pagination.items_total}*/}
			{/*    itemsPerPage={20}*/}
			{/*    pageCurrent={pagination.page_current}*/}
			{/*    pageTotal={pagination.page_total}*/}
			{/*    windowSizes={windowSizeModel.windowSizes}*/}
			{/*    urlDefault={path}*/}
			{/*    wrapperItem={<PaginatorElem />}*/}
			{/*/>*/}
		</React.Fragment>
	);
};

const Actions = pipe(withRouter, observer, inject("ApplicationModel"))(_Actions);

export default Actions;
